<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <p>{{ data.text }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button cdkFocusInitial [mat-dialog-close]="true">OK</button>
</div>
